import { calculateExtraTransactions } from './statisticsUtils';

/** Format TRY currency for display */
export const formatTry = (value) =>
  new Intl.NumberFormat('tr-TR', {
    style: 'currency',
    currency: 'TRY',
    maximumFractionDigits: 0,
  }).format(value || 0);

/** Preview revenue from report analysis + AOV (client-side) */
export const computeReportRevenuePreview = (report, aov) => {
  if (!aov || !report?.analysis?.length) {
    return { monthly: 0, yearly: 0 };
  }

  let bestMonthly = 0;
  let bestYearly = 0;
  const duration = report.testDuration || 14;

  report.analysis.forEach((analysis) => {
    if (analysis.resultStatus !== 'Kazandı' || !analysis.control) return;

    const variants =
      analysis.variants?.length > 0
        ? analysis.variants
        : analysis.variant
          ? [analysis.variant]
          : [];

    variants.forEach((variant) => {
      if (!variant) return;
      const extra = calculateExtraTransactions(
        analysis.control.conversions || 0,
        analysis.control.sessions || 0,
        variant.conversions || 0,
        variant.sessions || 0,
        1000,
        0.5,
        aov,
        duration,
      );
      if (extra.monthlyExtraRevenue > bestMonthly) {
        bestMonthly = extra.monthlyExtraRevenue;
        bestYearly = extra.yearlyExtraRevenue;
      }
    });
  });

  return { monthly: Math.round(bestMonthly), yearly: Math.round(bestYearly) };
};
